import React from 'react';
import { useAuth } from '@/features/auth/AuthContext';
import { Header, Button, PlusIcon, TooltipTrigger } from '@spark';
import './HomePageHeader.css';

export const HomePageHeader = ({ onCreateProject }) => {
    const { role } = useAuth();
    const isViewer = role === 'Viewer';

    const cta = (
        <Button
            className="home-page-header__create-project"
            variant="primary"
            size="medium"
            startIcon={<PlusIcon size="medium" />}
            disabled={isViewer}
            disableWhenReadOnly
            onClick={onCreateProject}
        >
            Create New Specific Model
        </Button>
    );

    return (
        <div className="fs-unmask" style={{ padding: '24px 0 32px 0' }}>
            <Header
                className="home-page-header"
                showBreadcrumb={false}
                showBackButton={false}
                title="Projects"
                subtitle="Create and manage your projects. Projects are your high-level goals, broken down into individual tasks. Each task is a specific use case you want to solve."
                actionBar={isViewer
                    ? <TooltipTrigger text="Viewers cannot create new projects">{cta}</TooltipTrigger>
                    : cta}
            />
        </div>
    );
};
